import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "overlay", "frame", "downloadLink", "thread" ]

  connect() {
    this.savedScrollTop = 0
    this.imageElement = null
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()

    this.savedScrollTop = this.threadTarget.scrollTop
    this.renderImage(event.params.src)
    this.downloadLinkTarget.href = event.params.downloadUrl
    this.overlayTarget.classList.remove("hidden")
    document.addEventListener("keydown", this.handleKeydown)
  }

  close(event) {
    event?.preventDefault()

    this.overlayTarget.classList.add("hidden")
    this.clearImage()
    this.threadTarget.scrollTop = this.savedScrollTop
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return

    this.close()
  }

  renderImage(src) {
    this.clearImage()
    this.imageElement = document.createElement("img")
    this.imageElement.src = src
    this.imageElement.alt = ""
    this.imageElement.className = "max-h-full max-w-full object-contain"
    this.frameTarget.appendChild(this.imageElement)
  }

  clearImage() {
    if (!this.imageElement) return

    this.imageElement.remove()
    this.imageElement = null
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    this.clearImage()
  }
}
